import { NICmsContentField, NICmsContentComponent } from '@icms/core/content';

/**
 * CMS fields for AB testing
 * Boolean value toggled by matching variant for experiment
 */
export const abIfExpSection: NICmsContentField.IField = {
    key: 'abIfExpSection',
    type: NICmsContentField.EFieldType.label,
    group: NICmsContentComponent.EFieldGroup.styles,
    title: 'AB Testing'
};

export const abIfExpField: NICmsContentField.IField = {
    key: 'styles.abIfExp',
    type: NICmsContentField.EFieldType.text,
    group: NICmsContentComponent.EFieldGroup.styles,
    title: 'Display only for experiment variant, syntax: (expeiment name) Variant',
    description: 'Example: (myExperiment) A,B, or another example: (myExperiment) !B'
};
